"use strict";

/**
 *  平台设置
 *  @module 操作属性
 */

import Vue from "@/main";

// 默认数据
const form = {
  operationMode: 0, //鼠标操作
};

// 保存提交 (存储至localStorage)
const saveOperationSettings = (data) => {
  localStorage.setItem("operationSettings", JSON.stringify(data));
};

// 对外暴露基本属性 / 取消保存
const exposureOperationSettings = () => {
  if (localStorage.getItem("operationSettings")) {
    return JSON.parse(localStorage.getItem("operationSettings"));
  } else {
    localStorage.setItem("operationSettings", JSON.stringify(form));
    return JSON.parse(JSON.stringify(form));
  }
};

// 处理效果
const setOperationEffect = (data, map = Vue.$GLOBAL.map) => {
  const { operationMode } = data;
  // 鼠标操作
  if (operationMode) {
    map.changeMouseModel(false);
  } else {
    map.changeMouseModel(true);
  }
};

export { saveOperationSettings, exposureOperationSettings, setOperationEffect };
